import { getSelectedCurrency } from '@/src/redux/slices/currencySlice'
import { useAppSelector } from '@/src/redux/store'
import { getConversionRateDetails, getCurrencyByLocale } from '@/src/utils/currency/formatCurrency'
import { isEmpty } from '@/src/utils/generalUtils'
import { useCallback, useMemo } from 'react'
import useSearchResults from '../../srp/useSearchResults'
import useFormatCurrency from '../useFormatCurrency'

const useFormatCurrencyForSrp = () => {
    const toCurrency = useAppSelector(getSelectedCurrency)
    const { currency: fromCurrency } = getCurrencyByLocale()
    const { formatCurrency } = useFormatCurrency()
    const { jsons } = useSearchResults()

    const formatCurrencyForSrp = useCallback(
        (price: number, usePrecision: boolean = true) => {
            const { currencyList = [] } = jsons || {}
            const conversionRateDetails = isEmpty(currencyList)
                ? { rate: 1, buffer: 0 }
                : getConversionRateDetails(currencyList, fromCurrency, toCurrency)
            const { rate = 1, buffer = 0 } = conversionRateDetails || {}

            return formatCurrency({
                toCurrency,
                rate,
                buffer,
                price,
                usePrecision
            })
        },
        [formatCurrency, toCurrency, jsons]
    )

    // Memoize the format function to prevent unnecessary re-renders
    const memoizedFormatCurrency = useMemo(
        () => ({
            formatCurrency: formatCurrencyForSrp
        }),
        [formatCurrencyForSrp]
    )

    return memoizedFormatCurrency
}

export default useFormatCurrencyForSrp
